import React from 'react';
import RecipeCard from '../recipes/RecipeCard';
import RecipeCardSkeleton from '../recipes/RecipeCardSkeleton';
import { Recipe } from '../../api/Recipe';
import { getAuthorColor } from '../../utils/colorUtils';
import { Box } from '../ui';

interface HomeRecipeGridProps {
  recipes: Recipe[];
  showDailySelection: boolean;
  loading: boolean;
  loadingMore: boolean;
  recipesPerPage: number;
  dailySelectionLabel: string;
  favoritePendingIds: string[];
  isFavorite: (recipeId: string) => boolean;
  onFavoriteToggle: (recipe: Recipe) => void;
  lastRecipeElementRef: (node: HTMLElement | null) => void;
}

const HomeRecipeGrid: React.FC<HomeRecipeGridProps> = ({
  recipes,
  showDailySelection,
  loading,
  loadingMore,
  recipesPerPage,
  dailySelectionLabel,
  favoritePendingIds,
  isFavorite,
  onFavoriteToggle,
  lastRecipeElementRef,
}) => {
  return (
    <>
      {recipes.map((recipe, index) => {
        const isDailySelection = showDailySelection && index === 0;
        const labelColor = recipe.authors
          ? getAuthorColor(recipe.authors.id, recipe.authors.color)
          : '#cccccc';

        return (
          <Box
            ref={recipes.length === index + 1 ? lastRecipeElementRef : null}
            key={recipe.id}
            fullHeight
            className="recipe-grid-item scroll-snap-align-start"
          >
            <RecipeCard
              recipe={recipe}
              isFavorite={isFavorite(recipe.id)}
              onFavoriteClick={() => {
                onFavoriteToggle(recipe);
              }}
              favoriteDisabled={favoritePendingIds.includes(recipe.id)}
              labelColor={labelColor}
              overlayBadgeText={isDailySelection ? dailySelectionLabel : undefined}
            />
          </Box>
        );
      })}
      {(loading || loadingMore) && (
        <Box role="status" aria-label="Chargement des recettes suivantes" display="contents">
          {[...Array(recipesPerPage)].map((_, index) => (
            <Box
              key={`skeleton-${index}`}
              fullHeight
              className="recipe-grid-item scroll-snap-align-start"
            >
              <RecipeCardSkeleton />
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default HomeRecipeGrid;
